/**
 * TourOrderItem.jsx
 * Created by Stephanie Condrey on 11/14/17.
 */

import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    orderItemTitle: PropTypes.string,
    orderItemDetailOne: PropTypes.string,
    orderItemDetailTwo: PropTypes.string,
    orderItemPrice: PropTypes.string
};

export default class TourOrderItem extends React.Component {
    render() {
        return (
            <div className="rec-order-item-row">
                <div className="rec-order-item-col">
                    <div className="h4">{this.props.orderItemTitle}</div>
                    <p>{this.props.orderItemDetailOne}</p>
                    <p>{this.props.orderItemDetailTwo}</p>
                </div>
                <div className="rec-order-item-col">
                    <p className="item-price">{this.props.orderItemPrice}</p>
                    <p className="item-actions"><a href="#/">Edit</a> &#124; <a href="#/">Remove</a></p>
                </div>
            </div>
        );
    }
}
TourOrderItem.propTypes = propTypes;
